module.exports = __webpack_public_path__ + "img/高压液冷超充.f1847095.png";